/* ====================================================
				NAV MENU ON MOBiLE
======================================================= */
jQuery( document ).ready(function($) {
console.log('nav menu show');
});
window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
window['prismCategoryBar4033V1'] = function(){
  if(typeof jQuery !== typeof undefined && jQuery("#shopify-section-header .header-wrap .mobile-nav-wrapper .mobile-nav").length && !jQuery('.prismCategoryBar4033V1').length){
    jQuery("body").addClass('prismCategoryBar4033V1');
    addSubCategoryStrip4033V1();
    console.log('hello');
  }else{
    window.requestAnimationFrame(prismCategoryBar4033V1);
    console.log('yes?');
  }
};
window.prismCategoryBar4033V1();
function addSubCategoryStrip4033V1(){
  var htm = '<div class="vwoCategoryBar">';
  htm += '<ul id="vwoHeaderCategory" class="mobile-nav">';
  htm += '<li class="mobile-nav__item mob_nav_item_monitors  border-bottom">';
  htm += '<a href="/collections/monitors" class="mobile-nav__link">Monitors</a>';
  htm += '</li>';
  htm += '<li class="mobile-nav__item mob_nav_item_monitor-arms  border-bottom">';
  htm += '<a href="/collections/monitor-arms" class="mobile-nav__link">Monitor Arms</a>';
  htm += '</li>';
  htm += '<li class="mobile-nav__item mob_nav_item_tvs  border-bottom">';
  htm += '<a href="/collections/tvs" class="mobile-nav__link">TVs</a>';
  htm += '</li>';
  htm += '<li class="mobile-nav__item mob_nav_item_tvstand  border-bottom">';
  htm += '<a href="/collections/tv-stands" class="mobile-nav__link">TV Stands</a>';
  htm += '</li>';
  htm += '<li class="mobile-nav__item mob_nav_item_soundbar  border-bottom">';
  htm += '<a href="/collections/soundbar" class="mobile-nav__link">Soundbars</a>';
  htm += '</li>';
  htm += '<li class="mobile-nav__item mob_nav_item_accessories  border-bottom">';
  htm += '<a href="/collections/accessories" class="mobile-nav__link">Accessories</a>';
  htm += '</li>';
  
  htm += '</ul></div>';
  // if(!jQuery(".vwoCategoryBar").length){
  //   jQuery("#shopify-section-header header.site-header").after(htm);
  // }
}

  jQuery(document).ready(function($) {
    if(window.location.href.match('/collections/tvs')){
        $(".mob_nav_item_tvs").addClass("active");
    }else if(window.location.href.match('/collections/tv-stands')){
        $(".mob_nav_item_tvstand").addClass("active");
    }else if(window.location.href.match('/collections/monitors')){
        $(".mob_nav_item_monitors").addClass("active");
    }else if(window.location.href.match('/collections/soundbar')){
        $(".mob_nav_item_soundbar").addClass("active");
    }else if(window.location.href.match('/collections/monitor-arms')){
        $(".mob_nav_item_monitor-arms").addClass("active");
    }else if(window.location.href.match('/collections/accessories')){
        $(".mob_nav_item_accessories").addClass("active");
    }
    
    
  });

/* =============================================
  		COLLECTION PAGE VARIANT SELECT // VARIANT COLOR HEIGHT ADJUSTMENT
================================================ */
jQuery( document ).ready(function($) {
  if ($(".colorlist li").hasClass("variant-item")) {
  //console.log('list has color variants');
  $(".colorlist").addClass('active');
  }
});
/* variant select // collection page */
jQuery(document).ready(function(){
    $(".variant-color").on("click", function(){
        var imgurl = $(this).attr("data-image");
      	var produrl = $(this).attr("data-url");
        var prodid = $(this).attr("data-id");
        var button = $(this).attr("data-button");
        
      	$(this).parent().parent().siblings('.grid-view-item__image').attr("src",imgurl);
      	$(this).parent().parent().siblings('.grid-view-item__link').attr("href",produrl);
        $(this).parent().parent().siblings('.cart.hidden-link').attr("href", "https://prismplus.com.au/cart/add?id[]="+ prodid);
        
      
        if(button != ''){
          $(this).parent().parent().siblings('.grid_shop').html('<a href="'+produrl+'">'+button+'</a>');
        }else{
          $(this).parent().parent().siblings('.grid_shop').html('<a href="'+produrl+'">SHOP NOW</a>');
        }
      	$(".variant-color").removeClass('selected');
        $(this).addClass('selected');
    });
});